// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TerminalController from "./terminal_controller"
application.register("terminal", TerminalController)

import PromptCloakerController from "./prompt_cloaker_controller"
application.register("prompt-cloaker", PromptCloakerController)
import PolicyController from "./policy_controller"
application.register("policy", PolicyController)

import DashboardController from "./dashboard_controller"
application.register("dashboard", DashboardController)

import MaskController from "./mask_controller"
application.register("mask", MaskController)

import ViolationsExpanderController from "./violations_expander_controller"
application.register("violations-expander", ViolationsExpanderController)

import CostAsyncPollerController from "./cost_async_poller_controller"
application.register("cost-async-poller", CostAsyncPollerController)

import TimeframeFilterController from "./timeframe_filter_controller"
application.register("timeframe-filter", TimeframeFilterController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import DocTocController from "./doc_toc_controller"
application.register("doc-toc", DocTocController)

import DocCalloutSyncController from "./doc_callout_sync_controller"
application.register("doc-callout-sync", DocCalloutSyncController)

import HooksInstallController from "./hooks_install_controller"
application.register("hooks-install", HooksInstallController)

import VerifierMethodTabsController from "./verifier_method_tabs_controller"
application.register("verifier-method-tabs", VerifierMethodTabsController)

import DeepAnalysisController from "./deep_analysis_controller"
application.register("deep-analysis", DeepAnalysisController)

import ViolationClustersController from "./violation_clusters_controller"
application.register("violation-clusters", ViolationClustersController)

import ShareChartController from "./share_chart_controller"
application.register("share-chart", ShareChartController)
